import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NetworkService } from '../../shared/network.service';
@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private pageChange = new BehaviorSubject('false');
  currentPage = this.pageChange.asObservable();

  constructor(private networkService: NetworkService,
    ) { }

    getDashboardCountApi() {
      return this.networkService.get("/api/homepage/cards/counts",null, null,'bearer');
    }

  createCircle(body:any) {
    return this.networkService.post("api/users/verifyEmail",body, null,'bearer');
  }
  getMemberList(query) {
    return this.networkService.get("api/users/userList?hideSelf=true&"+query,null, null,'bearer');
  }
  getTotalMembersCountApi() {
    return this.networkService.get("api/admins/counts",null, null,'bearer');
  }
  getpublicCircle(query) {
    return this.networkService.get("api/circles/circleList?"+query,null, null,'bearer');
    
  }
  getYourOwnCircle() {
    return this.networkService.get("api/circles/myCircles",null, null,'bearer');
  }
  resetpassword(req: any) {
    return this.networkService.post("api/user/verify/password/forgot", req, null, null);
  }

  uploadPdf(image: any) {
    const formData = new FormData();
    formData.append("image",image);
    return this.networkService.uploadImages("api/s3upload/image-upload", formData, null, "bearer");
  }
 

  getEventListDropDownApi() {
    return this.networkService.get("api/dropdowns/eventTypes",null, null,'bearer');
  }

  getAllEventListApi(query) {
    return this.networkService.get("api/events?"+query,null, null,'bearer');
  }
  getEventUserMemberList(query:any) {
    return this.networkService.get("api/circles/members?"+query,null, null,'bearer');
  }
  getCircleMemberList() {
    return this.networkService.get("api/circles/members?",null, null,'bearer');
  }
  uploadImage(image: any) {
    const formData = new FormData();
    formData.append("file",image);
    return this.networkService.uploadImages("api/s3upload/media-upload", formData, null, "bearer");
  }
 createEvent(req: any) {
    return this.networkService.post("api/events", req, null, "bearer");
  }
  updateEvent(req: any) {
    return this.networkService.put("api/events", req, null, "bearer");
  }
  DeleteEvent(query) {
    return this.networkService.delete("api/events/"+query,null, null,'bearer');
  }

  createConnetion(body:any) {
    return this.networkService.post("api/connectionRequests",body, null,'bearer');
  }
  removeConnetion(id:any) {
    return this.networkService.delete("api/connections/"+id,null, null,'bearer');
  }
  UpdateConnetion(body:any) {
    return this.networkService.put("api/connectionRequests",body, null,'bearer');
  }
  getResourceApi(query) {
    return this.networkService.get("api/resourceAndDiscussions/resource?",null, null,'bearer');
  }
  networkListApi(query) {
    return this.networkService.get("api/resourceAndUpdates/update?",null, null,'bearer');
  }
  getAllCircleNotification(query) {
    return this.networkService.get("api/circles/dashboardActivities?"+query,null, null,'bearer');
  }


  createDicussion(req: any) {
    return this.networkService.post("api/resourceAndDiscussions/discussion", req, null, "bearer");
  }
  updateDicussion(req: any) {
    return this.networkService.put("api/resourceAndDiscussions/discussion", req, null, "bearer");
  }
  replyDicussion(req: any) {
    return this.networkService.post("api/resourceAndDiscussions/discussion/reply", req, null, "bearer");
  }
  
  getDicussion(query) {
    return this.networkService.get("api/resourceAndDiscussions/discussion?"+query,null, null,'bearer');
  }
  getDicussionReply(query) {
    return this.networkService.get("api/resourceAndDiscussions/discussion/replies?"+query,null, null,'bearer');
  }
  getDicussionReplyThread(query) {
    return this.networkService.get("api/resourceAndDiscussions/discussion/second/replies?"+query,null, null,'bearer');
  }
  DeleteDicussion(query) {
    return this.networkService.delete("api/resourceAndDiscussions/discussion/"+query,null, null,'bearer');
  }
  DeleteReply(id) {
    return this.networkService.delete("api/resourceAndDiscussions/discussionReply/"+id,null, null,'bearer');
  }
  

  getCircleMembers(circleId:any) {
    return this.networkService.get("api/circles/members?circleId="+circleId,null, null,'bearer');
  }
  getdiscussionTags() {
    return this.networkService.get("api/resourceAndDiscussions/discussionTags",null, null,'bearer');
  }
  getPieChatData(circleId:any) {
    return this.networkService.get("api/circles/members?circleId="+circleId,null, null,'bearer');
  }
  getBarChatData(circleId:any) {
    return this.networkService.get("api/circles/members?circleId="+circleId,null, null,'bearer');
  }


  
 

  getUnreadMessageCount() {
    return this.networkService.get("api/chats/unreadCount",null, null,'bearer');
  }

getSecondReplyApi(query:any) {
  return this.networkService.get("api/resourceAndDiscussions/discussion/second/replies?"+query,null, null,'bearer');
}
getStudyAPI(query:any,body:any) {
  return this.networkService.post("tuftsapi/studies?"+query,body, null, null);
}
getDepartmentAPI(query:any) {
  return this.networkService.get("tuftsapi/studies/departments?"+query, null, null, 'bearer');
}
getDivisionAPI() {
  return this.networkService.get("tuftsapi/studies/divisions", null, null, 'bearer');
}
getDashboordCount(body:any) {
  return this.networkService.post("tuftsapi/studies/counts?", body, null, null);
}

updateStudyStatus(req: any) {
  return this.networkService.post("tuftsapi/studies/add/study/status", req, null, "bearer");
}

deleteStudyApi(req: any) {
  return this.networkService.post("tuftsapi/studies/delete/study/status", req, null, "bearer");
}

updateCalendarActiveStatusApi(req: any) {
  return this.networkService.put("tuftsapi/studies/update/calendar/status", req, null, "bearer");
}

approveServiceRequestCalendarApi (req:any) {
  return this.networkService.put("tuftsapi/studies/approve/calendar", req, null, "bearer");
}


getHtmlRender(body: any) {
  return this.networkService.get("api/project/banners", null, null, "bearer");
}

}

